/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Cpe1
 */
export interface Cpe1 {
}

/**
 * Check if a given object implements the Cpe1 interface.
 */
export function instanceOfCpe1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Cpe1FromJSON(json: any): Cpe1 {
    return Cpe1FromJSONTyped(json, false);
}

export function Cpe1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Cpe1 {
    return json;
}

export function Cpe1ToJSON(value?: Cpe1 | null): any {
    return value;
}

